import type { UseTVRemoteEventHandler } from "./types";

export const useTVRemoteEventHandler: UseTVRemoteEventHandler = (params) => {
  return () => {
    console.log("useTVRemoteEventHandler", params);
  };
};
